import * as DateHelper from "./helpers/date";
import * as DispatchHelper from "./helpers/dispatch";
import * as NumberHelper from "./helpers/numbers";
import * as PermissionsHelper from "./helpers/permissions";
import * as StringHelper from "./helpers/strings";
import RefundRequestStatuses from "./data/refundRequestStatuses"
import dispatchRequestBatchStatuses from "./data/DispatchRequestBatchStatuses";
import GenericHelpers from "./helpers/generic-helpers";

export default {
    computed: {
        canUserManageAllStores() {
            return this.hasPermission('canmanagealllocations')
        },
        dispatchRequestBatchStatuses() {
            return dispatchRequestBatchStatuses
        },
        today: DateHelper.today,
        tomorrow: DateHelper.tomorrow,
        dispatcherTypes: DispatchHelper.dispatcherTypes,
        currentLocation() {
            return (this.$store.state.locationsForUser[0])
                ? this.$store.state.locationsForUser[0]
                : {location_type: {}}
        },
        getViewPort: GenericHelpers.getViewport,
    },
    methods: {
        hasPermission: PermissionsHelper.hasPermission,
        hasAnyPermission: PermissionsHelper.hasAnyPermission,
        hasAllPermissions: PermissionsHelper.hasAllPermissions,
        hasLocationPermission: PermissionsHelper.hasLocationPermission,
        hasAnyLocationPermission: PermissionsHelper.hasAnyLocationPermission,
        hasLocation: PermissionsHelper.hasLocation,
        hasLocationId: PermissionsHelper.hasLocationId,
        isFeatureEnabled: PermissionsHelper.isFeatureEnabled,
        nl2br: StringHelper.nl2br,
    },
    filters: {
        datetimeshort(val) {
            let date = new Date(val)
            return date.toLocaleString('nl-NL', {
                'day': '2-digit',
                'month': '2-digit',
                'year': 'numeric',
                'hour': 'numeric',
                'minute': 'numeric',
            })
        },
        datetime: DateHelper.datetime,
        date: DateHelper.date,
        price: NumberHelper.price,
        ucfirst: StringHelper.ucfirst,
        uppercase: StringHelper.uppercase,
        dispatchRequestStatus: DispatchHelper.dispatchRequestStatus,
        dispatcherType(val) {
            return DispatchHelper.dispatcherType(val).display_name
        },
        dispatchRequestBatchStatus(val) {
            return dispatchRequestBatchStatuses[val]
        },
        refundRequestStatus(val) {
            return RefundRequestStatuses[val]
        },
    },

}
